import React, { useState, useCallback, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PTextarea from '../../common/PTextarea';
import { useDropzone } from 'react-dropzone';
import PMedia from '../../common/PMedia';
import PMediaExisting from '../../common/PMediaExisting';
import { ReactSortable } from "react-sortablejs";
import DateFnsUtils from '@date-io/date-fns';
import dateFormat from 'dateformat';
import Button from 'react-bootstrap/Button';
import { v4 as uuidv4 } from 'uuid';
import { toFixedTrunc } from '../../utils/helper';
import useDidMountEffect from '../../utils/useDidMountEffect';
import { getRandomArbitrary } from '../../utils/helper';
import { POST_TYPE, ROLES } from '../../utils/constants';
import { bytesToSize } from '../../utils/helper';
import { useDispatch } from 'react-redux';
import { setAlert, setShowPostAlbum, setOldCategories, setSelectedPost, setPostAction } from '../../../redux/actions';
import { setPost } from '../../../redux/actions/post';
import CategoryModal from '../CategoryModal';
import { connect, useSelector } from 'react-redux';
import { ppvPrice as DefaultPpvPrice } from '../../utils/rules';
import currency from 'currency.js';
import RoundCheckbox from '../RoundCheckbox';
import Stash from '../Stash';
import { setStashSelectedR, setStashShow } from '../../../redux/actions/stash';

import './style.scss';
import styled from 'styled-components';
import { captureException } from '@sentry/react';
import ModalPPVPrice from '../ModalPPVPrice';
import { Chip, FormControlLabel, IconButton, Menu, MenuItem, Popover, Radio, RadioGroup } from '@mui/material';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import moment from 'moment';
import PriceText from '../PriceText';
import CountDownTimer from '../CountDownTimer';
import { ModalPPVPriceContext } from '../ModalPPVPrice/context';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const RemoveContainer = styled.div`
    display: none;

    @media (max-width: 767px) {
        display: block;
    }
`;

const RemoveButton = styled.button`
    text-transform: uppercase;
    color: #fff;
    background: #fe7676;
    border: 0;
    padding: 4px;
    width: 100%;
    display: block;
    margin-top: 4px;

    text-align: center;
    font-size: 11px;
    border-radius: 8px;
}
`;

const PriceInformation = styled.div`
    background-color: #eee;
    color: #0097fe;
    padding: 8px 8px 8px 16px;
    margin: 8px 0;
    position: relative;
    border-radius: 25px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const ClosePriceInformation = styled.span`
`;

const currencyFormat = {
    precision: 2
};

const PCreatePost = ({
    user,

    settings,
    showStash,
    stash,
    stashItems,
    successHandler = () => ({}),
    schedule = false,
    profile = false,
    activePost,
    showAlbum,
    mode,
    action,
    onShop = false,
    ...rest
}) => {
    const maxFiles = 10;
    const maxFileSize = 1610612736; // 1.5GB

    const dispatch = useDispatch();

    const { categories } = useSelector((state) => state.category);

    const userInformation = JSON.parse(localStorage.getItem('user'));

    const [caption, setCaption] = useState('');
    const [error, setError] = useState('');
    const [files, setFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // const [editMode, setEditMode] = useState(false);
    const [captionPlaceholder, setCaptionPlaceholder] = useState('Create new post (add PPV posts to Shop)');
    const [postId, setPostId] = useState('');
    const [totalMedia, setTotalMedia] = useState(0);
    const [uploads, setUploads] = useState(0);
    const [show, setShow] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [isExpired, setIsExpired] = useState(false);
    const [postTypeAnchorEl, setPostTypeAnchorEl] = useState(null);
    const [postType, setPostType] = useState(POST_TYPE.SUBSCRIPTION_POST);

    const handleShow = () => setShow(!show);

    const [discard, setDiscard] = useState(true);
    const handleDiscard = () => {
        setDiscard(!discard);
    };

    const [selectedDate, setSelectedDate] = useState(moment());
    const stringDate = dateFormat(selectedDate, 'dddd, mmmm dd, yyyy, hh:MM TT');

    const [filesizeErrors, setFilesizeErrors] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [showAlbumTrigger, setShowAlbumTrigger] = useState(false);
    const [hasFreePreview, setHasFreePreview] = useState(false);
    const [freePreview, setFreePreview] = useState('');
    const [tempUpload, setTempUpload] = useState([]);
    const [isScheduled, setIsScheduled] = useState(false);

    const dispatchAlert = (body, type, title = '') => {
        dispatch(setAlert({
            body,
            type,
            title,
            show: true,
        }));
    };

    const onDropRejected = useCallback((errors) => {
        let countError = errors[0].errors[0].code === 'too-many-files'
            ? `Only ${maxFiles} files are accepted per post.`
            : null;

        if (countError) {
            dispatchAlert(countError, 'error');
            return;
        }

        let tmpErrors = [];

        errors.forEach(error => {
            if (error.errors.find(e => e.code === 'file-too-large')) {
                tmpErrors.push({
                    filename: error.file.name
                });
            }
        });

        if (tmpErrors.length > 0) {
            setFilesizeErrors(tmpErrors);
            let filenames = tmpErrors.map(e => e.filename).join(', ');
            dispatchAlert(`${filenames} file(s) are too large.`, 'error');
            return;
        }

        const errorMessage = errors[0].errors[0].message;
        setError(errorMessage);
        dispatchAlert(errorMessage, 'error');
    }, []);

    const [progressbar, setProgressbar] = useState([]);
    const [fileError, setFileError] = useState({});
    const [totalUploadedFiles, setTotalUploadedFiles] = useState(0);

    const hasActiveTimedDiscount = activePost?.expire_at ? moment.utc().local().isBefore(moment.utc(activePost.expire_at).local()) : false;

    useDidMountEffect(() => {
        let mounted = true;
        const fc = [];
        for (const catId of selectedCategories) {
            const target = categories.find((item) => item.id === catId);
            if (target) {
                fc.push(target);
            }
        }
        setFilteredCategories(() => fc);
        window.dispatchEvent(new CustomEvent('wall-album/checkchange', { detail: fc }));

        return () => {
            mounted = false;
        };
    }, [selectedCategories, categories]);

    useDidMountEffect(() => {
        setCaptionPlaceholder(action === 'edit' ? 'Edit post' : 'Create new post (add PPV posts to Shop)');
    }, [action]);

    const onDropAccepted = useCallback((acceptedFiles) => {
        let rank = files.length > 0 ? files.length : 0;
        let existingFiles = [];

        setHasError(false);

        const acceptedFilesLn = acceptedFiles.length;
        const filesLn = files.length;
        const totalFiles = filesLn + acceptedFilesLn;


        if (totalFiles > maxFiles) {
            dispatchAlert(`Only ${maxFiles} files are accepted per post.`, 'error');
            return;
        }

        acceptedFiles.forEach((file) => {
            const uuid = uuidv4();
            const cancelTokenSource = axios.CancelToken.source();
            const fileObj = {
                uuid: uuid,
                file: file,
                rank: rank++,
                image: URL.createObjectURL(file),
                loaded: 0,
                isLibrary: false,
                cancelTokenSource: cancelTokenSource
            };

            existingFiles.push(fileObj);

            const mediaIds = new Set(files.map(fileState => fileState.uuid));
            if (!mediaIds.has(fileObj.uuid)) {
                files.push(fileObj);
                setFiles([...files]);
            }

            uploadFile(fileObj);
        });

        existingFiles = [];
    }, [files]);

    const [done, setDone] = useState({});
    const uploadFile = (file) => {
        const formData = new FormData();
        formData.append('media', file.file, file.file.name);
        formData.append('uuid', file.uuid);
        formData.append('rank', file.rank);
        formData.append('loaded', file.loaded);
        formData.append('source', 'post');

        axios.post(`/api/medias`, formData, {
            cancelToken: file.cancelTokenSource.token,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
                const loaded = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                setProgressbar({
                    ...progressbar,
                    [file.uuid]: loaded > 85 ? getRandomArbitrary(85, 99) : loaded
                });
            },
        }).then(response => {
            setDone(response.data);
            const tmp = [...tempUpload];
            tmp.push(response.data);
            setTempUpload(tmp);
        }).catch(error => {
            console.error(error);
            if (axios.isCancel(error)) {
                dispatchAlert(error.message, 'warning');
            } else {
                setFileError(file);
            }
            // setTotalUploadedFiles(totalUploadedFiles => totalUploadedFiles - 1);
        });
    };

    useDidMountEffect(() => {
        let mounted = true;

        if (fileError && Object.keys(fileError).length > 0) {
            const index = files.findIndex(item => item.uuid == fileError.uuid);
            files.splice(index, 1);
            dispatchAlert(`Failed to upload file ${fileError.file.name}`, 'error');
        }

        return () => {
            mounted = false;
        };
    }, [fileError]);

    useDidMountEffect(() => {
        let mounted = true;
        const index = files.findIndex(item => item.uuid == done.uuid);
        const fileClones = JSON.parse(JSON.stringify(files));
        if (index < 0) {
            fileClones.push({
                ...done,
                isLibrary: true,
                loaded: 100,
                uuid: done.uuid,
                rank: done.rank,
            });
        } else {
            fileClones.splice(index, 1);
            let selectedClone = JSON.parse(JSON.stringify(stashItems));
            selectedClone.push(done);
            dispatch(setStashSelectedR([...selectedClone]));
        }

        const totalUpload = fileClones.reduce((accumulator, current) => {
            if (current.isLibrary) {
                return accumulator += 1;
            }

            return accumulator;
        }, 0);

        setUploads(totalUpload);
        setTotalUploadedFiles(totalUpload);
        setFiles([...fileClones]);

        return () => {
            mounted = false;
        };
    }, [done]);

    const {
        acceptedFiles,
        getRootProps,
        getInputProps,
        isDragActive,
    } = useDropzone({
        onDropRejected,
        onDropAccepted,
        accept: 'image/jpeg, image/png, video/mp4, video/quicktime, video/3gpp',
        maxFiles: 10,
        multiple: true,
        maxSize: maxFileSize
    });

    const handleRemove = (file) => {
        const index = stashItems.findIndex(item => item.media_id == file.media_id);
        if (index >= 0) {
            stashItems.splice(index, 1);
            dispatch(setStashSelectedR([...stashItems]));
        }

        // remove from tempUpload

        if (file.cancelTokenSource) {
            file.cancelTokenSource.cancel('File upload cancelled');
            // setTotalUploadedFiles(totalUploadedFiles => totalUploadedFiles - 1);
        }

        // check files
        const fileIndex = files.findIndex(item => item.uuid == file.uuid);

        if (fileIndex >= 0) {
            let cloned = JSON.parse(JSON.stringify(files));
            cloned.splice(fileIndex, 1);
            setFiles([...cloned]);
        }
    };

    const handleSort = (newState) => {
        const ranked = newState.map((state, index) => {
            return {
                ...state,
                rank: index
            };
        });

        dispatch(setStashSelectedR(ranked));
    };

    const handleCreatePost = (e) => {
        e.preventDefault();

        // this is to make sure that you cannot process anything if the loading state is still true.
        if (isLoading === true) {
            return;
        }

        if (ppvPrice > 0 && stashItems.length <= 0) {
            dispatchAlert('Please select at least 1 stash media', 'error');

            return;
        }

        if ((ppvPrice <= 0 && hasFreePreview) || (onShop && ppvPrice <= 0)) {
            dispatchAlert('Please enter a valid price', 'error');
            setPpvPriceError('Required');
            return;
        }

        setIsLoading(true);

        const existingFiles = stashItems.map((file, index) => {
            return {
                media_id: file.media_id,
                rank: index
            };
        });

        if (!caption.trim() && existingFiles.length <= 0) {
            setHasError(true);
            setIsLoading(false);
            return;
        }

        const route = activePost && Object.keys(activePost).length > 0
            ? `/api/posts/${activePost.id}`
            : '/api/posts';
        axios.post(route, {
            caption: caption,
            sched_date: selectedDate,
            existing_files: existingFiles,
            categories: selectedCategories,
            price: ppvPrice,
            free_preview: freePreview.media_id,
            is_discounted: isDiscounted,
            promo_price: promoPrice,
            // expiry_date: expiryDate
            expiry_date: expiry,
            on_shop: onShop,
            show_on_shop_and_posts: showOnShopAndPosts,
            post_type: postType
        }).then(response => {
            setPostId(response.data.id);
            const message = activePost && Object.keys(activePost).length > 0
                ? 'Post has been successfully updated'
                : 'Post has been successfully created';
            dispatchAlert(message, 'success');
            // setEditMode(false);
            // setCaptionPlaceholder('Create new post or Shop PPV…');
            resetForm();
            successHandler(true);
            setSelectedCategories([]);
            setIsLoading(false);
            setShowAlbumTrigger(false);
            dispatch(setStashSelectedR([]));

            dispatch(setSelectedPost({}));

            if (activePost && Object.keys(activePost).length > 0) {
                dispatch(setPost(response.data.post));
            }
        }).catch(error => {
            console.error({ error });
            setIsLoading(false);
            setPpvPriceError('');
        });
    };

    const resetExpiry = () => {
        setExpiry({
            days: 0,
            hours: 0,
            minutes: 0
        });
    };

    const resetPrevExpiry = () => {
        setPrevExpiry({
            days: 0,
            hours: 0,
            minutes: 0
        });
    };

    const resetPriceModal = () => {
        setPpvPrice('');
        setPromoPrice('');
        resetExpiry();
        setIsDiscounted(false);
        setPrevPpvPrice('');
        setPrevPromoPrice('');
        resetPrevExpiry();
        setPrevIsDiscounted(false);
    };

    const resetForm = () => {
        setFiles([]);
        setCaption('');
        setPostId('');
        setTotalMedia(0);
        setUploads(0);
        setSelectedDate(moment());
        setIsLoading(false);
        setDiscard(true);
        dispatch(setSelectedPost({}));
        setSelectedCategories([]);
        setFilteredCategories([]);
        setShowPrice(false);
        setShowOnShopAndPosts(false);
        dispatch(setStashSelectedR([]));
        dispatch(setPostAction(''));
        resetPriceModal();
        setPostType(POST_TYPE.SUBSCRIPTION_POST);
    };


    useDidMountEffect(() => {
        let mounted = true;
        if (action === 'edit' && activePost && Object.keys(activePost).length > 0) {
            const existingFiles = activePost.medias.map(media => {
                return media;
            });

            setUploads(existingFiles.length);

            dispatch(setStashSelectedR(existingFiles));

            const strippedCaption = activePost.caption ? activePost.caption.replace(/(<([^>]+)>)/ig, '') : '';
            setCaption(strippedCaption);
            // setCaptionPlaceholder('Create new post or Shop PPV…');
            setTotalMedia(existingFiles.length);

            $([document.documentElement, document.body]).animate({
                scrollTop: $("#new_post_form").offset().top - 200
            }, 1000);

            setSelectedCategories(activePost.categories.map(category => category.id));
            if (activePost.price > 0) {
                setExpiryDate(moment.utc(activePost.expire_at));
                setPpvPrice(activePost.price);
                setPromoPrice(activePost.promo_price);

                if (activePost.promo_price > 0 && hasActiveTimedDiscount) {
                    setIsDiscounted(true);
                } else {
                    setIsDiscounted(false);
                }

                setShowPriceInfo(true);
            } else {
                setShowPriceInfo(false);
            }

            setHasFreePreview(activePost.has_free_preview);

            setPostType(activePost.post_type);
            setPostTypeDirty(true);
        }

        return () => {
            mounted = false;
        };
    }, [activePost]);

    const updateThumbnailHandler = (file, thumb) => {
        const index = files.findIndex(item => item.uuid == file.uuid);
        const existingFiles = JSON.parse(JSON.stringify(files));
        existingFiles[index].thumb_path = thumb.file_path;
        setFiles([
            ...existingFiles
        ]);
    };
    const [showPrice, setShowPrice] = useState(false);
    const [ppvPriceError, setPpvPriceError] = useState('');
    const [ppvPrice, setPpvPrice] = useState('');
    const [helpText, setHelpText] = useState('');
    const [promoPrice, setPromoPrice] = useState('');
    const [isDiscounted, setIsDiscounted] = useState(false);
    const [prevPpvPrice, setPrevPpvPrice] = useState('');
    const [prevPromoPrice, setPrevPromoPrice] = useState('');
    const [prevIsDiscounted, setPrevIsDiscounted] = useState(false);
    const [showPriceInfo, setShowPriceInfo] = useState(false);
    const [expiryDate, setExpiryDate] = useState('');
    const [expiry, setExpiry] = useState({
        days: 0,
        hours: 0,
        minutes: 0
    });
    const [prevExpiry, setPrevExpiry] = useState({
        days: 0,
        hours: 0,
        minutes: 0
    });
    const [showOnShopAndPosts, setShowOnShopAndPosts] = useState(false);
    const [prevShowOnShopAndPosts, setPrevShowOnShopAndPosts] = useState(false);
    const [postTypeDirty, setPostTypeDirty] = useState(false);

    const handleShowPrice = () => {
        // set default prev values when the price modal is reopened after clicking the OK button and not sending/submitting the PPV
        if (!showPrice && !prevPpvPrice && ppvPrice) {
            setPrevPpvPrice(ppvPrice);
            setPrevPromoPrice(promoPrice);
            setPrevExpiry(expiry);
            setPrevIsDiscounted(isDiscounted);
            setPrevShowOnShopAndPosts(showOnShopAndPosts);
        }

        setShowPrice(!showPrice);
    };

    useEffect(() => {
        let mounted = true;
        if (ppvPrice > 0) {
            let price = ppvPrice.toString().replace(/^0+/, '');
            price = price.replace(/[\.\%]/g, function (match, offset, all) {
                return match === "." ? (all.indexOf(".") === offset ? '.' : '') : '';
            });
            setPpvPrice(toFixedTrunc(price, 2));

            if (!postTypeDirty) {
                setPostType(POST_TYPE.FREE);
            }
        }

        if (!ppvPrice || ppvPrice <= 0) {
            setFreePreview('');
            setHasFreePreview(false);
            setPostType(POST_TYPE.SUBSCRIPTION_POST);
        }

        return () => {
            mounted = false;
        };
    }, [ppvPrice]);

    useEffect(() => {
        let mounted = true;
        if (showPrice) {
            setShowPriceInfo(false);

            // reset date and time to the current datetime + 1 hour show price modal is opened and promoPrice if there is no promo price
            if (!promoPrice) {
                resetExpiry();
            } else {
                if (activePost && activePost.expire_at) {
                    const currDate = moment.utc().local();
                    const promoExpiry = moment.utc(activePost.expire_at).local();

                    // get days, hours, and minutes
                    if (currDate < promoExpiry) {
                        const days = promoExpiry.diff(currDate, 'days');

                        const diff = moment.duration(promoExpiry.unix() - currDate.unix(), 'seconds');
                        const hours = diff.hours();
                        const minutes = diff.minutes();

                        setExpiry({
                            days, hours, minutes
                        });
                    }
                }
            }
        } else {
            if (ppvPrice > 0) {
                setShowPriceInfo(true);
            }

            if (!promoPrice) {
                setIsDiscounted(false);
            }
        }

        return () => {
            mounted = false;
            setShowPriceInfo(false);
        };
    }, [showPrice]);

    const [minPpvPrice, setMinPpvPrice] = useState(DefaultPpvPrice.minAmount);
    const [maxPpvPrice, setMaxPpvPrice] = useState(DefaultPpvPrice.maxAmount);
    const getSettings = async () => {
        await axios.get(`/api/settings`, {
            params: {
                only: 'min_ppv_price,max_ppv_price'
            }
        })
            .then(response => {
                const data = Object.assign({}, ...response.data);
                const minPpv = Object.keys(data).length > 0 && data.min_ppv_price
                    ? data.min_ppv_price
                    : DefaultPpvPrice.minAmount;
                setMinPpvPrice(parseFloat(minPpv));

                const maxPpv = Object.keys(data).length > 0 && data.max_ppv_price
                    ? data.max_ppv_price
                    : DefaultPpvPrice.maxAmount;
                setMaxPpvPrice(parseFloat(maxPpv));
            });
    };

    useEffect(() => {
        let mounted = true;

        // check if authenticated user is an SU
        if (userInformation && userInformation.role === ROLES.SU) {
            // add a jquery click event listener to the create post's footer buttons
            $('.createpost-media-btn > .createpost-media-btn').on('click', handleDisabledFooterButtonClick);
        }
        getSettings();

        return () => {
            mounted = false;

            // check if authenticated user is an SU
            if (userInformation && userInformation.role === ROLES.SU) {
                // remobe the jquery click event listener on the create post's footer buttons
                $('.createpost-media-btn > .createpost-media-btn').off('click', handleDisabledFooterButtonClick);
            }

            dispatch(setSelectedPost({}));
        };
    }, []);

    useEffect(() => {
        let mounted = true;

        if (ppvPrice != '') {
            if (ppvPrice < minPpvPrice) {
                setPpvPriceError(true);
                setHelpText(`Min ${currency(minPpvPrice).format(currencyFormat)} USD`);
            }

            if (ppvPrice > minPpvPrice) {
                setPpvPriceError(true);
                setHelpText(`Max ${currency(maxPpvPrice).format(currencyFormat)} USD`);
            }

            if (ppvPrice >= minPpvPrice && ppvPrice <= maxPpvPrice) {
                setPpvPriceError(false);
                setHelpText(`Min ${currency(minPpvPrice).format(currencyFormat)} USD`);
            }
        } else {
            setPpvPriceError(false);
            setHelpText(`Min ${currency(minPpvPrice).format(currencyFormat)} USD`);
        }

        return () => {
            mounted = false;
        };
    }, [ppvPrice, minPpvPrice, maxPpvPrice]);

    useEffect(() => {
        let mounted = true;

        if (filesizeErrors.length > 0) {
            let tmp = `<p>The media file you tried to upload is too big.  The maximum size is ${bytesToSize(maxFileSize)}</p><ul>`;
            filesizeErrors.forEach(error => {
                tmp += `<li>Media file name: ${error.filename}</li>`;
            });
            tmp += '</ul><p>Tip: Try trimming your media and upload again.</p>';

            dispatchAlert(tmp, '', 'Media file is too big to upload');
        }

        return () => {
            mounted = false;
        };
    }, [filesizeErrors]);

    const handleAddToWallAlbum = () => {
        setShowAlbumTrigger(true);
        dispatch(setShowPostAlbum(true));
        dispatch(setOldCategories(activePost?.categories || []));
    };

    const handleFreePreview = () => {
        setHasFreePreview(hasFreePreview => !hasFreePreview);
    };

    const handleSelect = file => {
        if (freePreview && freePreview.media_id == file.media_id) {
            setFreePreview('');
        } else {
            setFreePreview(file);

            const index = stashItems.findIndex(f => f.media_id == file.media_id);
            let tmp = JSON.parse(JSON.stringify(stashItems));
            if (index >= 0) {
                const selected = tmp.splice(index, 1);
                tmp.unshift(selected[0]);
            }

            tmp.forEach((t, i) => {
                t.rank = i;
            });

            dispatch(setStashSelectedR(tmp));
        }
    };

    const handleOnSort = () => {
        if (hasFreePreview) {
            setFreePreview(stashItems[0]);
        }
    };

    useEffect(() => {
        let mounted = true;

        if (hasFreePreview) {
            setFreePreview(stashItems[0]);
        } else {
            setFreePreview('');
        }

        return () => {
            mounted = false;
        };
    }, [hasFreePreview]);


    const handleShowStash = (e) => {
        e.preventDefault();
        dispatch(setStashShow(true));
    };

    // useEffect(() => {
    //     if (!showStash) {
    //         document.body.style.overflow = "auto";
    //     }
    // }, [showStash]);

    useDidMountEffect(() => {
        if (stashItems.length > 0 || caption.length > 0) {
            setHasError(false);
        }
    }, [caption, stashItems]);

    const handleAcceptDate = () => {
        setDiscard(false);
        setIsScheduled(true);
    };

    useDidMountEffect(() => {
        if (discard) {
            setIsScheduled(false);
            resetPriceModal();
        }
    }, [discard]);

    useEffect(() => {
        let mounted = true;
        if (stashItems && stashItems.length <= 1) {
            setHasFreePreview(false);
        }

        return () => {
            mounted = false;
        };
    }, [stashItems]);

    // const handlePriceInformationClose = () => {
    //     resetPriceModal();
    // };

    useEffect(() => {
        if (!ppvPrice || ppvPrice <= 0) {
            setPromoPrice('');
            setIsDiscounted(false);
        }
    }, [ppvPrice]);

    const handleEndTime = (postID) => {
    };

    const handlePriceModalClose = (param = '') => {
        if (param === 'ok') {
            setPrevPpvPrice(ppvPrice);
            setPrevPromoPrice(promoPrice);
            setPrevExpiry(expiry);
            setPrevIsDiscounted(isDiscounted);
            setPrevShowOnShopAndPosts(showOnShopAndPosts);
        } else if (param === 'cancel') {
            setPpvPrice(prevPpvPrice);
            setPromoPrice(prevPromoPrice);

            if (prevExpiry) {
                setExpiry(prevExpiry);
            } else {
                resetExpiry();
            }
        }

        setShowPrice(false);
    };

    // trigger a click event on the create post text area when SU clicks on any footer button to display the create error modal
    const handleDisabledFooterButtonClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        document.getElementById('createpost-with-emoji-textarea').click();
    };

    const handleShowPostType = (event) => {
        setPostTypeAnchorEl(event.currentTarget);
    };

    const handleClosePostType = () => {
        setPostTypeAnchorEl(null);
    };

    const handlePostTypeChange = event => {
        setPostType(event.target.value);
        setPostTypeAnchorEl(null);
        setPostTypeDirty(true);
    };

    return (
        <>
            {schedule && activePost && Object.keys(activePost).length <= 0 &&
                <>
                    <div className={'createpost-scheduler-message' + `${!discard ? ' active' : ''}`}>
                        <p>
                            <span><FontAwesomeIcon icon={['fas', 'calendar-check']} /></span>
                            Scheduled for
                            {' '}
                            <span className="scheduleposttextdate">
                                {stringDate}
                            </span>
                        </p>
                        <div className="createpost-scheduler-discard" onClick={handleDiscard}>
                            <FontAwesomeIcon icon={['fas', 'times-circle']} />
                        </div>
                    </div>
                </>
            }

            {show && <div className="createpost-datetime-wrapper">
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <MobileDateTimePicker
                        // hideTabs={false}
                        minDate={moment()}
                        open={show}
                        value={selectedDate}
                        onChange={setSelectedDate}
                        onAccept={handleAcceptDate}
                        onClose={handleShow}
                        format="EEEE, MMMM dd, yyyy, hh:mm"
                    />
                </LocalizationProvider>
            </div>}

            {
                ppvPrice > 0 && showPriceInfo
                    ? <PriceInformation className="create-ppv-price">
                        <div>
                            <span>Price: <PriceText price={ppvPrice} discountedPrice={promoPrice} isDiscounted={isDiscounted} /> {promoPrice && (isDiscounted || hasActiveTimedDiscount) ? <React.Fragment> Limited offer expires in {
                                expiry.days > 0 || expiry.hours > 0 || expiry.minutes > 0 ?
                                    (
                                        (expiry.days > 0 ? (expiry.days > 1 ? `${expiry.days} days ` : '1 day ') : '') +
                                        (expiry.hours > 0 ? (expiry.hours > 1 ? `${expiry.hours} hrs ` : '1 hr ') : '') +
                                        (expiry.minutes > 0 ? `${expiry.minutes} min` : '')
                                    ) : <CountDownTimer dateTime={activePost.expire_at} onEndTime={handleEndTime} isUTC={true} />
                            }</React.Fragment> : ''} </span>
                        </div>
                        <ClosePriceInformation>
                            <IconButton
                                color='primary'
                                onClick={resetPriceModal}
                            >
                                <i className='fal fa-times search-clear-icon'></i>
                            </IconButton>
                        </ClosePriceInformation>
                    </PriceInformation>
                    : ''
            }

            {
                ppvPrice > 0
                    ? <>
                        {
                            !user.creator.free_subscription
                                ? <Chip
                                    variant='outlined'
                                    color='primary'
                                    icon={<i className='fa-regular fa-tag' />}
                                    label='PPV requires paid subscription for the purchase'
                                    size='small'
                                    sx={{
                                        '& .MuiChip-icon': {
                                            marginLeft: '8px'
                                        }
                                    }}
                                />
                                : null
                        }

                        {
                            user.creator.free_subscription
                                ? <Chip
                                    variant='outlined'
                                    color='primary'
                                    icon={<i className='fa-regular fa-tag' />}
                                    label={postType == POST_TYPE.FREE || postType == POST_TYPE.PPV_WITH_FREE_SUBSCRIPTION
                                        ? 'PPV can be purchased by Free and Paid Subscribers'
                                        : 'PPV requires paid subscription to purchase'
                                    }
                                    size='small'
                                    sx={{
                                        '& .MuiChip-icon': {
                                            marginLeft: '8px'
                                        }
                                    }}
                                />
                                : null
                        }
                    </>
                    : null
            }

            {
                ppvPrice <= 0 && user.creator && user.creator.free_subscription && postType == POST_TYPE.FREE
                    ? <Chip
                        variant='outlined'
                        color='primary'
                        icon={<i className='fa-regular fa-tag' />}
                        label='Free post'
                        size='small'
                        sx={{
                            '& .MuiChip-icon': {
                                marginLeft: '8px'
                            }
                        }}
                    />
                    : null
            }

            <form
                id="new_post_form"
                name="new_post"
                method="post"
                encType="multipart/form-data"
            >
                <PTextarea
                    onFocus={() => setShowAlbumTrigger(true)}
                    caption={caption}
                    setCaption={setCaption}
                    calendarStatus={show}
                    hasError={hasError}
                    setHasError={setHasError}
                    placeholder={captionPlaceholder}
                    isPost={true}
                    categoryButton={
                        (caption.length > 0 || files.length > 0 || showAlbumTrigger || showAlbum) ? (
                            <>
                                {selectedCategories.length > 0
                                    ? (
                                        <div className='wall-album-btn'>
                                            <span
                                                onClick={handleAddToWallAlbum}
                                                title="Wall Albums"
                                                style={{
                                                    cursor: 'pointer',
                                                    color: '#0097fe',
                                                    fontSize: 14,
                                                    lineHeight: '16px',
                                                }}
                                            >
                                                <i className="fa-regular fa-rectangle-history"></i>
                                                <span className="span-cat-item">Albums</span>
                                                {filteredCategories.map((cat) => (
                                                    <span key={cat.id} className="span-cat-item">{cat.name}</span>
                                                ))}
                                            </span>
                                        </div>
                                    ) : (
                                        <div className='wall-album-btn'>
                                            <span
                                                onClick={handleAddToWallAlbum}
                                                title="Wall Albums"
                                                style={{
                                                    cursor: 'pointer',
                                                    color: '#0097fe',
                                                    fontSize: 14,
                                                    lineHeight: '16px',
                                                }}
                                            >
                                                <i className="fa-regular fa-rectangle-history-circle-plus"></i>
                                                <span className="span-cat-item">Add post to Wall Albums</span>
                                            </span>
                                        </div>
                                    )}
                            </>
                        ) : null
                    }
                />

                <div className="createpost-footer-buttons">
                    <div className="createpost-media-btn-wrapper">
                        <div className="createpost-media-btn">
                            {
                                <div className="createpost-media-btn" {...getRootProps({ className: 'createpost-media-btn dropzone' })}>
                                    <input {...getInputProps()} disabled={userInformation && userInformation.role === ROLES.SU} />
                                    {
                                        profile ?
                                            <a className="no-bg createpost-profile-media-btn" style={{ cursor: 'pointer' }}>
                                                <i className="fa-regular fa-image"></i> <span><b>Photo/Video</b></span>
                                            </a>
                                            : <a style={{ cursor: 'pointer', fontSize: '22px' }} title="Upload Media">
                                                <i className="fa-regular fa-image"></i>
                                            </a>
                                    }
                                    {/* <input {...getInputProps()} /> */}
                                </div>
                            }

                            <div
                                className="createpost-media-btn action-btn"
                                onClick={handleShowStash}
                            >
                                <i className="fa-regular fa-photo-film" title="Open Stash"></i>
                            </div>
                            {activePost && Object.keys(activePost).length <= 0 && <div className="createpost-media-btn createpost-schedule-btn action-btn">
                                <a onClick={handleShow}>
                                    <i className="fa-regular fa-calendar-clock" title="Schedule Post"></i>
                                </a>
                            </div>
                            }

                            <div
                                className={`createpost-media-btn action-btn ppv-post showprice${showPrice ? ' showprice-active' : ''}`}
                                onClick={handleShowPrice}
                            >
                                <i className="fa-regular fa-circle-dollar" aria-hidden="true" title={showPrice ? 'Remove Price' : 'Add Price'} />
                            </div>

                            <ModalPPVPriceContext.Provider value={{
                                showPrice,
                                handlePriceModalClose,
                                ppvPrice,
                                setPpvPrice,
                                promoPrice,
                                setPromoPrice,
                                isDiscounted,
                                setIsDiscounted,
                                minPpvPrice,
                                maxPpvPrice,
                                prevPpvPrice,
                                prevPromoPrice,
                                prevIsDiscounted,
                                setPrevPpvPrice,
                                setPrevPromoPrice,
                                setPrevIsDiscounted,
                                setShowPriceInfo,
                                expiry,
                                setExpiry,
                                dispatchAlert,
                                onShop,
                                showOnShopAndPosts,
                                setShowOnShopAndPosts,
                                postType,
                                setPostType,
                            }}>
                                <ModalPPVPrice onPosts={true} />
                            </ModalPPVPriceContext.Provider>

                            {
                                userInformation && userInformation.creator && Object.keys(userInformation).length > 0 && userInformation.creator.free_subscription
                                    ? <div
                                        className="createpost-media-btn action-btn"
                                        onClick={handleShowPostType}
                                    >
                                        <i className="fa-regular fa-tag"></i>
                                    </div>
                                    : null
                            }
                        </div>
                    </div>
                    {
                        (
                            action !== "edit" &&
                            (
                                caption.length > 0 ||
                                stashItems.length > 0
                            )
                        ) ?
                            <div className={'createpost-submit-btn-wrapper post-btn'}>
                                <Button
                                    className={`btn theme-btn text-center post-button  ${isLoading ? "font-italic" : ""}`}
                                    onClick={handleCreatePost}
                                    disabled={(isLoading || ppvPriceError)}
                                    style={{ height: '33px', width: 'inherit' }}
                                >
                                    {(!isLoading) ? 'POST' : 'Posting...'}
                                </Button>
                            </div>
                            :
                            <div className={`createpost-submit-btn-wrapper text-right submit-post${schedule && isScheduled && activePost && Object.keys(activePost).length <= 0 ? ' submit-post-schedule' : ''} ${ppvPrice > 0 && !showPrice ? ' is-ppv' : ''}`}>
                                {
                                    (action === "edit") && userInformation && userInformation.role !== ROLES.SU && activePost && Object.keys(activePost).length > 0
                                        ? <>
                                            {
                                                !isLoading && <Button
                                                    className="btn btn-default cancel cancel-post cancel-btn"
                                                    onClick={resetForm}
                                                    style={{ height: '33px', width: 'inherit' }}
                                                >Cancel</Button>
                                            }
                                            <Button
                                                className={`btn theme-btn text-center ${isLoading ? "save-button font-italic" : ""}`}
                                                onClick={handleCreatePost}
                                                disabled={isLoading}
                                                style={{ height: '33px', width: 'inherit' }}
                                            >
                                                {((action === "edit") && !isLoading) ? 'SAVE' : 'Saving...'}
                                            </Button>
                                        </>
                                        : ''
                                }
                            </div>
                    }
                </div>
                <div className="post__free-preview-box">
                    {
                        !showPrice && Boolean(ppvPrice > 0) && stashItems.length > 1 && <div className="free-preview mb-0">
                            <RoundCheckbox
                                label="Free Preview"
                                checked={hasFreePreview}
                                onChange={handleFreePreview}
                            />
                        </div>
                    }
                </div>
                <div className="files mt-1" style={{ ourline: '2px solid red' }}>
                    {
                        ((files && files.length > 0) || stashItems && stashItems.length > 0) && <ReactSortable
                            tag="div"
                            className="files__container"
                            list={stashItems}
                            setList={(newState) => handleSort(newState)}
                            animation={200}
                            onChoose={() => { setIsDragging(true); }}
                            onUnchoose={() => { setIsDragging(false); }}
                            onSort={handleOnSort}
                            draggable=".files__file"
                            handle=".free-preview__movable"
                            delayOnTouchOnly={true}
                            delay={2}
                            swap
                        >
                            {
                                stashItems.map((file, index) => {
                                    return <div
                                        className={`files__file${freePreview && Object.keys(freePreview).length > 0 && file.media_id == freePreview.media_id ? ' files__file-active' : ''}`}
                                        key={file.media_id}
                                    >
                                        <PMediaExisting
                                            file={file}
                                            index={index}
                                            remove={handleRemove}
                                            changeableCoverPic={false}
                                            playable={false}
                                        />
                                        {hasFreePreview && <span
                                            className='free-preview__select'
                                            onClick={() => handleSelect(file)}
                                        ></span>}

                                        {file.media_id == freePreview.media_id && <span className="free-preview__label">
                                            Free Preview
                                        </span>}

                                        <div className='free-preview__movable'>
                                            <i className="fa-solid fa-grip-dots"></i>
                                        </div>

                                        <RemoveContainer>
                                            <RemoveButton type="button" onClick={() => handleRemove(file)}>
                                                Remove
                                            </RemoveButton>
                                        </RemoveContainer>
                                    </div>;
                                })
                            }

                            {
                                files.map((file, index) => (
                                    files.length === index + 1 && files.length > 0
                                        ? <React.Fragment key={file.uuid}>
                                            <div
                                                key={file.uuid}
                                                className={`files__file${file.media_id == freePreview.media_id ? ' files__file-active' : ''}`}
                                            >
                                                <div className="files__file-file">
                                                    {
                                                        !!file.isLibrary
                                                            ? <PMediaExisting file={file} index={index} remove={handleRemove} updateThumbnailHandler={updateThumbnailHandler} playable={false} />
                                                            : <PMedia file={file} index={index} remove={handleRemove} progress={progressbar} />
                                                    }
                                                    {hasFreePreview && <span
                                                        className='free-preview__select'
                                                        onClick={() => handleSelect(file)}
                                                    ></span>}
                                                </div>
                                                {
                                                    ((Object.keys(activePost).length <= 0) || activePost.price === null)
                                                    && <div className="draggable d-block d-md-none d-lg-none d-xl-none">
                                                        <div
                                                            onClick={(e) => handleRemove(file)}
                                                            style={{
                                                                textAlign: 'center',
                                                                padding: '4px',
                                                                background: '#fe7676',
                                                                color: '#fcfcfc',
                                                                fontSize: '11px',
                                                                borderRadius: '8px',
                                                                marginTop: 8,
                                                                marginBottom: 4
                                                            }}>
                                                            {!file.isLibrary ? 'CANCEL' : 'REMOVE'}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </React.Fragment>
                                        : <div
                                            key={file.uuid}
                                            className={`files__file${file.media_id == freePreview.media_id ? ' files__file-active' : ''}`}
                                        >
                                            <div className="files__file-file">
                                                {
                                                    !!file.isLibrary
                                                        ? <PMediaExisting file={file} index={index} remove={handleRemove} updateThumbnailHandler={updateThumbnailHandler} playable={false} />
                                                        : <PMedia file={file} index={index} remove={handleRemove} progress={progressbar} />
                                                }

                                                {hasFreePreview && <span
                                                    className='free-preview__select'
                                                    onClick={() => handleSelect(file)}
                                                ></span>}
                                            </div>
                                            {
                                                ((Object.keys(activePost).length <= 0) || activePost.price === null)
                                                && <div className="draggable d-block d-md-none d-lg-none d-xl-none">
                                                    <div
                                                        onClick={(e) => handleRemove(file)}
                                                        style={{
                                                            textAlign: 'center',
                                                            padding: '4px',
                                                            background: '#fe7676',
                                                            color: '#fcfcfc',
                                                            fontSize: '11px',
                                                            borderRadius: '8px',
                                                            marginTop: 8,
                                                            marginBottom: 4
                                                        }}>
                                                        {!file.isLibrary ? 'CANCEL' : 'REMOVE'}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                ))
                            }

                        </ReactSortable>
                    }

                </div>
            </form>
            {
                showAlbum && <CategoryModal
                    show={showAlbum}
                    setSelectedCategories={setSelectedCategories}
                    selectedCategories={selectedCategories}
                />
            }

            {
                showStash
                    ? <Stash source="post" numUploaded={totalUploadedFiles} onMessageOrPost={true} />
                    : null
            }

            <Popover
                id="postType-menu"
                anchorEl={postTypeAnchorEl}
                open={Boolean(postTypeAnchorEl)}
                onClose={handleClosePostType}
                MenuListProps={{
                    'aria-labelledby': 'postType-button',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <div style={{ padding: '0 8px' }}>
                    <div>
                        <strong>Post Type</strong>
                    </div>

                    <RadioGroup
                        aria-labelledby="post-type-group"
                        name="post-type-group"
                    >
                        <FormControlLabel
                            value={POST_TYPE.FREE}
                            control={
                                <Radio
                                    sx={{ '& .MuiRadio-root': { padding: '0 8px' } }}
                                    checked={
                                        postType == POST_TYPE.FREE || postType == POST_TYPE.PPV_WITH_FREE_SUBSCRIPTION
                                    }
                                    onChange={handlePostTypeChange}
                                />
                            }
                            label="Post unlocked for Free Followers and Paid Subscribers"
                            sx={{
                                '& .MuiRadio-root': { padding: '0 8px' },
                                marginBottom: '8px'
                            }}
                        />
                        <FormControlLabel
                            value={POST_TYPE.SUBSCRIPTION_POST}
                            control={
                                <Radio
                                    sx={{ '& .MuiRadio-root': { padding: '0 8px' } }}
                                    checked={
                                        postType == POST_TYPE.SUBSCRIPTION_POST || postType == POST_TYPE.PPV_WITH_PAID_SUBSCRIPTION
                                    }
                                    onChange={handlePostTypeChange}
                                />
                            }
                            label="Post unlocked for Paid Subscribers only"
                        />
                    </RadioGroup>
                </div>
            </Popover>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        showAlbum: state.post.showAlbum,
        mode: state.category.mode,
        activePost: state.post.selectedPost,
        action: state.post.action,
        settings: state.privaGlobal.settings,
        showStash: state.stash.show,
        stash: state.stash,
        stashItems: state.stash.stashSelected,
        user: state.user.user
    };
};

export default connect(mapStateToProps)(PCreatePost);
